import React from 'react';
import './feedbacks.css'
import { Star } from "@mui/icons-material"; 
import { useGetAllReviewQuery } from '../../services/feedbackApi';
import afatar from "../../images/femaleAfatar.png";

function Feedbacks() {
  const { data, isLoading, isError, error } = useGetAllReviewQuery();

  if (isLoading) return (
    <div className="loading-spinner">
      <div className="spinner"></div>
      <p>Loading reviews...</p>
    </div>
  );
  
  if (isError) return (
    <div className="error-message">
      <h2>An error occurred</h2>
      <p>{error?.error || 'Failed to load reviews'}</p>
    </div>
  );

  const reviews = [...(data || [])].reverse();

  const renderStars = (rating) => {
    const starCount = rating / 20;
    return Array.from({ length: 5 }).map((_, i) => (
      <Star 
        key={i} 
        sx={{ 
          color: i < starCount ? "#eef163" : "#ddd",
          fontSize: '1.5rem'
        }} 
      />
    ));
  };

  return (
    <section className="feedback-section">
      <h1 className="section-title">Customers Reviews</h1>
      
      <div className="cards-grid">
        {reviews.map((review) => (
          <div key={review.id} className="feedback-card">
            <img 
              src={afatar} 
              alt={`${review.customer.first_Name} ${review.customer.last_Name}`} 
              className="user-avatar"
            />
            <h3 className="user-name">
              {review.customer.first_Name} {review.customer.last_Name}
            </h3>
            
            <div className="rating-stars">
              {renderStars(review.rating)}
            </div>
            
            <p className="review-content">{review.content}</p>
            
            <p className="review-date">
              {new Date(review.reviewDate).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
            </p>
            
            <div className="product-info">
              Product Reviewed: {review.productReviewed.product_Name}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Feedbacks;